'use client';

import React from 'react';
import { BadgeCheck } from 'lucide-react';

// "Free with most insurance" reassurance shown in the booking flow (start +
// confirm steps), mirroring how major pharmacies present vaccine pricing.
export function InsuranceDisclaimer({ className = '' }: { className?: string }) {
  return (
    <div
      className={`flex items-start gap-2.5 rounded-xl border border-emerald-100 bg-emerald-50 px-4 py-3 ${className}`}
    >
      <BadgeCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
      <p className="text-sm leading-relaxed text-emerald-800">
        <span className="font-semibold">Vaccines are free with most insurance plans.</span>{' '}
        Just bring your insurance card to your visit — no insurance? Ask us about low-cost options.
      </p>
    </div>
  );
}
